import { PrimeReactProvider } from "primereact/api";
import { DataView } from "primereact/dataview";
import React from "react";
import "primereact/resources/themes/lara-light-blue/theme.css";

const primeReactNonce = {
  nonce: window.__CSP_NONCE__,
};

export default function PrimeReactDataView(props) {
  return (
    <div id="primeReactStyles" className="primeReactWrapper">
      <PrimeReactProvider value={primeReactNonce}>
        <div className="card">
          <DataView {...props} />
        </div>
      </PrimeReactProvider>
    </div>
  );
}
